import PropTypes from 'prop-types';
import classes from './ThumbnailFile.module.css';

export default function ThumbnailFileImage({ url }) {
    return <img src={url} alt="" className={classes.image} />;
}

ThumbnailFileImage.propTypes = {
    url: PropTypes.string.isRequired,
};
